<template>
  <div class="container mx-auto p-4 mb-4 rounded-md bg-brand-taupe-100">
    <h3 class="text-brand-blue-400 text-2xl font-semibold" v-html="section.title"></h3>
    <div class="mb-6" v-html="section.body"></div>
    <div class="divide-y">
      <Questions :questions="section.questions" :review="review" :form="form" :admin-view="adminView"
        @update="$emit('update')" />
      <div v-if="review.status === 'submitted'" class="container mx-auto mb-4">
        <h3 class="mt-2 mb-4 font-semibold text-brand-blue-400">Section Score</h3>
        <div :class="sectionScoreBorderColourClass" v-html="sectionScoreMeaning"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Questions from "./Questions";

export default {
  components: {
    Questions,
  },
  computed: {
    sectionScoreBorderColourClass() {
      let score = this.review.scores.find(s => s.section_id === this.section.id);
      // debugger;
      return "border-l-8 p-3 " + ((score && score.class) ?? "");
    },
    sectionScoreMeaning() {
      let score = this.review.scores.find(s => s.section_id === this.section.id);

      return (score && score.meaning) ?? "N/A";
    },
  },
  emits: ["update"],
  props: ["section", "review", "form", "adminView"],
};
</script>
